








































import { Component, Vue, Provide } from 'vue-property-decorator';
import MyNav from '@/components/nav/Index.vue'; // nav
import {
  Action, Mutation, State, Getter, namespace,
} from 'vuex-class';
import {
  Button, Table, TableColumn, Message, Input, Tabs, TabPane,
} from 'element-ui';
import Decisive from '@/servers/modules/decisive/index';
// server
    @Component({
      components: {
        MyNav,
        Table,
        TableColumn,
        Button,
        Tabs,
        TabPane,
        Input,
      },
    })
export default class extends Vue {
  @Mutation public setSkeletonDescribe:any;

  @Getter public skeleton: any;

  // 左侧菜单栏
  @Getter public scaleCommonIndex: any;

  // 当前选项
  private buttonActive: number = 0;

  // 切换选项展示
  private buttonData: any = [
    {
      name: '总进度',
    },
    {
      name: '总掌握度',
    },
    {
      name: '总正确率',
    },
  ];

  // 表格样式
  private tableHeaderClassName() {
    return 'table-header';
  }

  private tableRowClassName(row:any) {
    let classStr = 'table-row';
    if (row.row.ranking < 4) {
      classStr += ' rank-three';
    }
    return classStr;
  }

  // 排行图片
  private tableDataImg:any={
    1: require('@/assets/images/ui-word/rank1.png'),
    2: require('@/assets/images/ui-word/rank2.png'),
    3: require('@/assets/images/ui-word/rank3.png'),
  };

  // 表格数据
  private tableData:any = [];

  // 三个表格全部数据
  private rankData:any = [];

  // 我的个人排行榜信息
  private myRanking:any ={}

  // 点击按钮的表头变化
  private buttonActiveName:string = '';

  private async created() {
    this.setSkeletonDescribe(false);
    this.title = '';
    this.getAllData(0);
  }

  private async getAllData(type:number) {
    // 清空数据
    this.tableData = [];
    this.myRanking = {};
    const data = {
      classCode: '123',
      processDefinitionId: window.LS.get('basicData').refID,
    };
    console.log(data);
    const res = await Decisive.rankingList(data);
    console.log(res);
    // 获取
    this.rankData = res.data.data;
    if (type == 0) {
      this.tableData = this.rankData.learningProcessRateRankingList;
      this.myRanking.rate = this.rankData.myRankingsInfo.learningProcessRate;
      this.myRanking.num = this.rankData.myRankingsInfo.learningProcessRateRanking;
    } else if (type == 1) {
      this.tableData = this.rankData.masteryRateRankingList;
      this.myRanking.rate = this.rankData.myRankingsInfo.masteryRate;
      this.myRanking.num = this.rankData.myRankingsInfo.masterRateRanking;
    } else if (type == 2) {
      this.tableData = this.rankData.accuracyRateRankingList;
      this.myRanking.rate = this.rankData.myRankingsInfo.accuracyRate;
      this.myRanking.num = this.rankData.myRankingsInfo.accuracyRateRanking;
    } else {
      this.tableData = ' ';
    }
  }

  private changeButton() {
    this.getAllData(Number(this.buttonActive));
  }
}
